type ReimbursableInvoiceIdentity = {
   readonly invoice_id?: unknown;
   readonly invoice_reference?: unknown;
};

/** Keep the invoice reference whole; only the final session date is a suffix. */
export const formatReimbursableInvoiceIdentity = (invoice?: ReimbursableInvoiceIdentity | null) => {
   const rawId = typeof invoice?.invoice_id === 'string' ? invoice.invoice_id : '';
   const explicitReference = invoice?.invoice_reference;
   // Null carries no Stripe invoice source; receipt-backed IDs remain usable.
   const hasExplicitReference = explicitReference != null;
   const reference =
      typeof explicitReference === 'string' && explicitReference.trim() ?
         explicitReference.trim()
      :  '';
   const dateSuffix = rawId.match(/-\d{8}$/)?.[0] ?? '';

   return {
      header: reference && dateSuffix ? `INV-${reference}${dateSuffix}` : rawId,
      reference: hasExplicitReference ? reference : rawId.replace(/-\d{8}$/, ''),
   };
};

/** Export only identified invoices; nullable references retain legacy receipts. */
export const canExportReimbursableInvoice = (invoice?: ReimbursableInvoiceIdentity | null) => {
   const rawId = typeof invoice?.invoice_id === 'string' ? invoice.invoice_id.trim() : '';
   if (!rawId || rawId.startsWith('-')) return false;
   if (!formatReimbursableInvoiceIdentity(invoice).reference.trim()) return false;
   if (invoice?.invoice_reference != null) {
      return (
         typeof invoice.invoice_reference === 'string' &&
         invoice.invoice_reference.trim().length > 0 &&
         typeof invoice.invoice_id === 'string' &&
         /-\d{8}$/.test(invoice.invoice_id)
      );
   }
   return true;
};
